import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';

import {
  TabsModule,
  FilterModule,
  DetailsModule,
  PaginationModule,
  OrdersModule,
  SettingsModule,
  ToolbarModule,
  TableModule,
} from 'beyond-util';

import { VrsteSpotaComponent } from './vrste-spota.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    DetailsModule,
    PaginationModule,
    OrdersModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    NgxSpinnerModule,
  ],
  entryComponents: [VrsteSpotaComponent],
  declarations: [VrsteSpotaComponent],
  exports: [VrsteSpotaComponent],
})
export class VrsteSpotaModule {}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/vrste-spota/vrste-spota.module.ts